import lang from '../../../../lib/language';
import { Earning } from '../../../../lib/models/fundamental/types';
import { isEarningReported } from '../../../../lib/store/fundamental/helpers';
import { INVALID_VALUE } from '../../../../lib/util/types';

import { formatEarningsCurrency, formatEarningsRowDateLabel } from '../../earningsCalendar.helpers';
import EarningsStatusBadge from '../EarningsStatusBadge/EarningsStatusBadge';

import { formatEarningsRevenue } from './earningsReportHelpers';
import EarningsSurpriseValue from './EarningsSurpriseValue';

import styles from './CurrentReportCard.module.scss';

type Props = {
  earning: Earning;
};

const CurrentReportCard = ({ earning }: Props): JSX.Element => {
  const isReported = isEarningReported(earning);
  const revenueValue = isReported ? earning.revenue : earning.revenueEst;
  const revenueLabel = isReported ? lang.earningsReportDetailsRevenue() : lang.earningsReportDetailsRevenueEst();
  const epsLabel = isReported ? lang.earningsReportDetailsEpsSurprise() : lang.earningsReportDetailsEpsEst();
  const formattedEpsEst = earning.epsEst
    ? formatEarningsCurrency(earning.epsEst, earning.currency, earning.symbol)
    : INVALID_VALUE;

  return (
    <div className={styles.card}>
      <div className={styles.leftColumn}>
        <div className={styles.statusRow}>
          <span className={styles.dateLabel}>{formatEarningsRowDateLabel(earning.date)}</span>
          <span className={styles.dotSeparator}>•</span>
          <EarningsStatusBadge time={earning.time} reportStatus={earning.reportStatus} />
        </div>
        <div className={styles.revenueRow}>
          <span>{revenueLabel}</span>
          <span className={styles.revenueValue}>
            {' '}{formatEarningsRevenue(revenueValue, earning.currency, earning.symbol)}
          </span>
        </div>
      </div>
      <div className={styles.rightColumn}>
        <span className={styles.epsLabel}>{epsLabel}</span>
        {isReported ? (
          <EarningsSurpriseValue
            surprise={earning.epsSurprise}
            surprisePercent={earning.epsSurprisePercent}
            currency={earning.currency}
            symbol={earning.symbol}
            showArrow
          />
        ) : (
          <span className={styles.epsEstValue}>{formattedEpsEst}</span>
        )}
      </div>
    </div>
  );
};

export default CurrentReportCard;
